import { ThemeService } from './../../shared/theme-service/theme.service';
import { Account } from './../models/account';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint, Sine } from 'gsap';
import { AutenticationService } from '../autentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Auth } from '../Auth';
import { Access } from '../models/access';
import { AuthMessage } from '../models/auth-message';
import { EventTypes } from '../../shared/EventTypes';
import { AppOnlyFeatureService, PASSWORD_BLOCKED_TITLE, PASSWORD_BLOCKED_NOTICE } from '../../shared/app-only-feature/app-only-feature.service';
import * as $ from 'jquery';

@Component({
	selector: 'app-my-cpf',
	templateUrl: './my-cpf.component.html',
	styleUrls: ['./my-cpf.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MyCpfComponent implements OnInit, OnDestroy {
	corTextoBotaoDesabilitado: any;
	corBotaoDesabilitado: any;
	canSend = false;
	sending = false;
	formVerifyCpf: FormGroup;
	cpf = '';
	active = true;
	view = '[data-component="my-cpf"]';
	isWhiteLabel= false;
	isOpenBank: boolean;

	constructor(
		private authService: AutenticationService,
		private formBuilder: FormBuilder,
		private themeService: ThemeService,
		private appOnlyFeatureService: AppOnlyFeatureService
	) {
		this.formVerifyCpf = formBuilder.group({
			'cpf': [null, Validators.required],
			'remember': [null]
		});

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.MY_CPF, (data) => {
			this.active = true;
			this.show(data);
		});
	}

	ngOnInit() {

		this.isOpenBank = this.themeService.isOpenBank();

		if (this.themeService.themeConfigs) {
			this.corBotaoDesabilitado = this.themeService.CorBotaoDesabilitado ? this.themeService.CorBotaoDesabilitado : '';
			this.corTextoBotaoDesabilitado = this.themeService.CorTextoBotaoDesabilitado ? this.themeService.CorTextoBotaoDesabilitado : '';
			this.isWhiteLabel = this.themeService.getIdWhiteLabel() !== undefined ? true : false;
		}

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.MY_CPF);
	}

	/**
	 * Verifica se o CPF foi preenchido
	 * @param cpf:String
	 */
	verifyCpf(cpf: string) {
		this.cpf = cpf;
		if ( cpf.length > 13 ) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}
	}

	/**
	 * Envia CPF e retorna lista de Contas do usuário, e dados do mesmo.
	 */
	send() {

		if ( !this.sending && this.canSend && this.formVerifyCpf.valid ) {
			this.sending = true;
			Auth.rememberMyUser = this.formVerifyCpf.controls.remember.value;
			this.authService.getUserByCpf(this.formVerifyCpf.value.cpf).subscribe((access: Access) => {

				this.sending = false;

				Auth.acceptTerms = access.acceptTerms;
				Auth.termsText = access.termsText;
				Auth.hasSecurityQuestions = access.hasSecurityQuestions;

				if (access.exists) {
					if ( !Auth.acceptTerms ) {
						AppEventDispatcher.dispatch( EventTypes.TERMS.TERMS, { show: true, text: Auth.termsText, acceptHandler: this, access: access });
					}else {
						this.checkAfterTerms(access);
					}
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
					this.sending = false;
				}

			}, error => {
				this.sending = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
					msg: navigator.onLine ? error.error ? error.error.Mensagem : 'Erro inesperado. Favor tentar novamente' : 'Você está sem conexão com internet. Por favor, tente novamente mais tarde' });
			});

		}

	}

	checkAfterTerms(access: Access) {
		if (access.exists) {
			if ( access.hasPassAccess && access.hasPassTransaction ) {
				this.changeToLoginScene();
			} else if (access.passAccessBlocked) {
				this.appOnlyFeatureService.openNotice(PASSWORD_BLOCKED_NOTICE, PASSWORD_BLOCKED_TITLE, '420px');
			} else if (!access.hasPassTransaction) {
				this.changeToRedefinePassword(access.hasPassTransaction);
			}
			else {
				this.changeToDefinePassword(access.hasPassTransaction);
			}
		} else {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
		}
	}

	changeToLoginScene() {
		this.hide();
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.USER_AND_PASS, {delay: .2});
	}

	changeToDefinePassword(hasPassTransaction) {
		this.hide();

		Auth.definePassword = true;
		Auth.defineSignature = !hasPassTransaction;

		TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut});
		TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

		const message = new AuthMessage();
					message.buttonTitle = 'Continuar';
					message.delay = .2;
					message.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
					message.eventData = { show: true };
					message.hasButton = true;
					message.title = 'Olá, vamos definir sua senha?';
					message.text = 'Vamos te ajudar a defini-la, é fácil e rápido. Vamos lá?';
					message.withPreload = true;

		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);
	}

	changeToRedefinePassword(hasPassTransaction) {
		this.hide();

		Auth.definePassword = false;
		Auth.defineSignature = !hasPassTransaction;

		TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut});
		TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

		const message = new AuthMessage();
					message.buttonTitle = 'Continuar';
					message.delay = .2;
					message.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
					message.eventData = { show: true };
					message.hasButton = true;
					message.title = 'Olá, vamos redefinir sua senha?';
					message.text = 'Vamos te ajudar a redefini-la, é fácil e rápido. Vamos lá?';
					message.withPreload = true;

		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);

	}


	show(data) {
		const interval = setInterval(() => {
			if ($(this.view).length > 0) {

				if (data.fromDefinePassword) {
					if ($(window).width() > 992) {
						TweenMax.to('[data-component="login"]', .8, { width: 380, ease: Quint.easeOut});
						TweenMax.to('[data-component="login"] .logo', .8, { scale: 1, top: 25, ease: Quint.easeOut});
					}
					TweenMax.to(this.view, .6, {delay: .4, left: '50%', ease: Quint.easeOut});
				} else {
					if (data.direction === 'LEFT_TO_RIGHT') {
						TweenMax.set(this.view, { left: '-150%' });
					}
					TweenMax.to('[data-component="login"]', .8, { height: 450, ease: Sine.easeOut});
					TweenMax.to(this.view, .6, {left: '50%', top: this.isWhiteLabel ? '150' : '170', ease: Quint.easeOut});
				}


				clearInterval(interval);
			}
		}, 10);

	}

	hide() {
		TweenMax.to(this.view, 1.6, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.canSend = false;
			this.sending = false;
			this.active = false;
			this.formVerifyCpf.controls.remember.setValue(false);
		}});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/my-cpf/my-cpf.component.ts